module.exports = __webpack_public_path__ + "img/stock.a5fd5753.png";